import { React, useState, useEffect, useCallback, useRef, useContext } from "react";
import Button from "@mui/material/Button";
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import GridNoRow from '../../../../common/GridNoRow';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import axios from "axios";
import noImg from "../../../../img/noimg.png"
import styled from "styled-components";
import Select from 'react-select';
import { AppContext } from '../../../../AppStore';
import Moment from 'moment';
import "moment/locale/ko";
import Swal from "sweetalert2";
import '../../../../css/datagrid.css';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { useNavigate, useLocation } from "react-router-dom";

const CompanySetting = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const appStore = useContext(AppContext);
    const [MenuID, setMenuID] = useState(0);
    const [MenuName, setMenuName] = useState('');
    const [MenuUpdateExistYN, setMenuUpdateExistYN] = useState('N');
    const [MenuUpdateYN, setMenuUpdateYN] = useState('N');
    const [MenuDeleteExistYN, setMenuDeleteExistYN] = useState('N');
    const [MenuDeleteYN, setMenuDeleteYN] = useState('N');
    const [tabID, setTabID] = useState('1');
    const [menuOption, setMenuOption] = useState([]);
    const [typeOption, setTypeOption] = useState([]);
    const [groupOption, setGroupOption] = useState([]);
    const [ynOption, setYNOption] = useState([]);
    const companyNameRef = useRef(null);
    const [inputs, setInputs] = useState({
        company_id:0,
        company_cd:'',
        company_type:0,
        company_group:0,
        company_customer_type:'',
        company_number:'',
        company_law_number:'',
        company_name:'',
        company_kpi_key:'',
        company_conditions:'',
        company_jongmok:'',
        company_ceo:'',
        company_ceo_phone:'',
        company_ip_control_yn: 'N',
        company_address_post:'',
        company_address:'',
        company_address_addition:'',
        company_contact_name:'',
        company_contact_phone:'',
        company_contact_mail:''
    });
    const [hardwareOption, setHardwareOption] = useState([{value:'P', label:'PC'},{value:'T', label:'테블릿'},{value:'S', label:'스마트폰'}]);
    const [licenseRows, setLicenseRows] = useState([]);
    const [licenseOriginRows, setLicenseOriginRows] = useState([]);
    const [updateLicenseRows, setUpdateLicenseRows] = useState([]);
    const [licenseColumns, setLicenseColumns] = useState([]);
    const [hardwareRows, setHardwareRows] = useState([]);
    const [hardwareOriginRows, setHardwareOriginRows] = useState([]);
    const [updateHardwareRows, setUpdateHardwareRows] = useState([]);
    const [hardwareColumns, setHardwareColumns] = useState([]);
    const [ipRows, setIpRows] = useState([]);
    const [updateIpRows, setUpdateIpRows] = useState([]);
    const [ipColumns, setIpColumns] = useState([]);
    const [licenseColumnVisibilityModel, setLicenseColumnVisibilityModel] = useState({
        id: false,
        license_start_date: true,
        license_end_date: true,
        license_reg_user_name: true,
        license_reg_datetime: true,
        license_comment: true
    });
    const [hardwareColumnVisibilityModel, setHardwareColumnVisibilityModel] = useState({
        id: false,
        hardware_type: true,
        hardware_uuid: true,
        hardware_reg_user_name: true,
        hardware_reg_datetime: true,
        hardware_comment: true
    });
    const [ipColumnVisibilityModel, setIpColumnVisibilityModel] = useState({
        id: false,
        company_allow_ip: true,
        ip_reg_user_id: false,
        ip_reg_user_name: true,
        ip_reg_datetime: true,
        ip_update_user_id: false,
        ip_update_user_name: true,
        ip_update_datetime: true
    });
    const [updateFlag, setUpdateFlag] = useState(false);

    useEffect(() => {
        const accessList = JSON.parse(localStorage.getItem("nav"));
        
        if (Array.isArray(accessList) && accessList.filter(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).length > 0) {
            setMenuID(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_id);
            setMenuName(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_name);
            setMenuUpdateExistYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_update_exist_yn);
            setMenuDeleteExistYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_delete_exist_yn);
            setMenuUpdateYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_update_yn);
            setMenuDeleteYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_delete_yn);
            setUpdateFlag(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_update_yn === 'Y' && String(localStorage.getItem('user_login_id')).includes('admin'))
        }else{
            Swal.fire({
                title: '<p style="color:red">접근 권한 오류</p>',
                text: '화면에 접근 권한이 없습니다.',
                confirmButtonText: '확인',
                confirmButtonColor: '#7066e0',
                timer:5000,
                timerProgressBar: true
            }).then((value) => {
                return navigate(-1);
            });
        }
    }, []);

    useEffect(() => {
        if(String(MenuID) !== String(0) && MenuID != null){
            handleSetting();
            handleInitSelect();
            handleView();
        }
    }, [MenuID]);

    useEffect(() => {
        /*
        let ADD_YN= 'Y'
        for(let i=0; i<hardwareRows.length; i++){
            if(hardwareRows[i].row_type === 'A' && hardwareRows[i].update_type === 'N'){
                ADD_YN = "N";
            }
        }

        if(ADD_YN === 'Y' && updateFlag){
            setHardwareRows((hardwareRows) => [...hardwareRows, { 
                id: Number(appStore.getMaxListID(hardwareRows))+1,
                hardware_type: '',
                hardware_uuid: '',
                hardware_reg_user_name: '',
                hardware_reg_datetime: '',
                row_type:'A',
                update_type: 'N'
            }]);
        }
        */
    }, [hardwareRows]);

    useEffect(() => {
        /*
        let ADD_YN= 'Y'

        for(let i=0; i<licenseRows.length; i++){
            if(licenseRows[i].row_type === 'A' && licenseRows[i].update_type === 'N'){
                ADD_YN = "N";
            }
        }

        if(ADD_YN === 'Y' && updateFlag){
            setLicenseRows((licenseRows) => [...licenseRows, { 
                id: Number(appStore.getMaxListID(licenseRows))+1,
                license_start_date: '',
                license_end_date: '',
                license_reg_user_name: '',
                license_reg_datetime: '',
                row_type:'A',
                update_type: 'N'
            }]);
        }
        */
    }, [licenseRows]);

    useEffect(() => {
        let ADD_YN= 'Y'

        for(let i=0; i<ipRows.length; i++){
            if(ipRows[i].row_type === 'A' && ipRows[i].update_type === 'N'){
                ADD_YN = "N";
            }
        }

        if(ADD_YN === 'Y' && updateFlag){
            setIpRows((ipRows) => [...ipRows, { 
                id: Number(appStore.getMaxListID(ipRows))+1,
                company_allow_ip: '',
                ip_reg_user_id: 0,
                ip_reg_user_name: '',
                ip_reg_datetime: '',
                ip_update_user_id: 0,
                ip_update_user_name: '',
                ip_update_datetime: '',
                row_type:'A',
                update_type: 'N'
            }]);
        }
    }, [ipRows]);

    const handleSetting = () => {
        setLicenseColumns([
            /*
            (MenuUpdateYN === "Y"?
                {
                    field: 'actions',
                    headerName: '동작',
                    width: 55,
                    type:'actions',
                    disableClickEventBubbling: true,
                    getActions: (params) => [
                        ((params.row.update_type === "U")? 
                        <GridActionsCellItem icon={<DeleteIcon color={ MenuUpdateYN === "Y" && updateFlag? "error" : "grey"} />} onClick={() => {licenseDeleteClick(params)}} label="Delete" disabled={ MenuUpdateYN === "Y" && updateFlag? false : true } />
                        : (MenuUpdateYN === "Y" && params.row.row_type === "A" && params.row.update_type === "N")? 
                        <GridActionsCellItem icon={<AddIcon color={ "secondary" } />} onClick={() => {licenseAddClick(params)}} label="Add" />
                        :<GridActionsCellItem icon={<DeleteIcon color={ MenuUpdateYN === "Y" && updateFlag? "error" : "grey"} />} onClick={() => {licenseDeleteClick(params)}} label="Delete" disabled={ MenuUpdateYN === "Y" && updateFlag? false : true } />
                        )
                    ],
                    headerAlign: 'center', 
                    align:'center'
                } : {}),
            */
            { field: 'id', headerName: 'company_license_seq', width: 0, headerAlign: 'center' },
            { field: 'license_start_date', headerName: '시작일자', width: 120, headerAlign: 'center', align:'center', editable: true,
                valueFormmatter: (params) => {
                    if (typeof params === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(params) && !isNaN(new Date(params).getTime())) {
                    }else{
                        return '';
                    }
                },
             },
            { field: 'license_end_date', headerName: '종료일자', width: 120, headerAlign: 'center', align:'center', editable: true,
                valueFormmatter: (params) => {
                    if (typeof params === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(params) && !isNaN(new Date(params).getTime())) {
                        return params;
                    }else{
                        return '';
                    }
                },
             },
            { field: 'license_reg_user_name', headerName: '등록자', width: 110, headerAlign: 'center', align:'center', editable: true },
            { field: 'license_reg_datetime', headerName: '등록일시', width: 160, headerAlign: 'center', align:'center' }
        ]);

        setHardwareColumns([
            /*
            (MenuUpdateYN === "Y"?
                {
                    field: 'actions',
                    headerName: '동작',
                    width: 55,
                    type:'actions',
                    disableClickEventBubbling: true,
                    getActions: (params) => [
                        ((params.row.update_type === "U")? 
                        <GridActionsCellItem icon={<DeleteIcon color={ MenuUpdateYN === "Y" && updateFlag? "error" : "grey"} />} onClick={() => {licenseDeleteClick(params)}} label="Delete" disabled={ MenuUpdateYN === "Y" && updateFlag? false : true } />
                        : (MenuUpdateYN === "Y" && params.row.row_type === "A" && params.row.update_type === "N")? 
                        <GridActionsCellItem icon={<AddIcon color={ "secondary" } />} onClick={() => {licenseAddClick(params)}} label="Add" />
                        :<GridActionsCellItem icon={<DeleteIcon color={ MenuUpdateYN === "Y" && updateFlag? "error" : "grey"} />} onClick={() => {licenseDeleteClick(params)}} label="Delete" disabled={ MenuUpdateYN === "Y" && updateFlag? false : true } />
                        )
                    ],
                    headerAlign: 'center', 
                    align:'center'
                } : {}),
            */
            { field: 'id', headerName: 'company_hardware_seq', width: 0, headerAlign: 'center' },
            { field: 'hardware_type', headerName: '유형', type: 'singleSelect', width: 100,  valueOptions: () => hardwareOption ?? [], valueFormmatter: ({  value }) => hardwareOption.find((opt) => String(opt.value) === String(value))?.label ?? '', editable: true, headerAlign: 'center', align:'center' },
            { field: 'hardware_uuid', headerName: '고유ID', width: 310, headerAlign: 'center', align:'center', editable: true },
            { field: 'hardware_reg_user_name', headerName: '등록자', width: 110, headerAlign: 'center', align:'center', editable: true },
            { field: 'hardware_reg_datetime', headerName: '등록일시', width: 160, headerAlign: 'center', align:'center' }
        ]);

        setIpColumns([
            (MenuUpdateYN === "Y"?
                {
                    field: 'actions',
                    headerName: '동작',
                    width: 55,
                    type:'actions',
                    disableClickEventBubbling: true,
                    getActions: (params) => [
                        ((params.row.update_type === "U")? 
                        <GridActionsCellItem icon={<DeleteIcon color={ MenuUpdateYN === "Y" && updateFlag? "error" : "grey"} />} onClick={() => {licenseDeleteClick(params)}} label="Delete" disabled={ MenuUpdateYN === "Y" && updateFlag? false : true } />
                        : (MenuUpdateYN === "Y" && params.row.row_type === "A" && params.row.update_type === "N")? 
                        <GridActionsCellItem icon={<AddIcon color={ "secondary" } />} onClick={() => {licenseAddClick(params)}} label="Add" />
                        :<GridActionsCellItem icon={<DeleteIcon color={ MenuUpdateYN === "Y" && updateFlag? "error" : "grey"} />} onClick={() => {licenseDeleteClick(params)}} label="Delete" disabled={ MenuUpdateYN === "Y" && updateFlag? false : true } />
                        )
                    ],
                    headerAlign: 'center', 
                    align:'center'
                } : {}),
            { field: 'id', headerName: 'company_ip_seq', width: 0, headerAlign: 'center' },
            { field: 'company_allow_ip', headerName: '허용IP', width: 150, headerAlign: 'center', align:'center', editable: true },
            { field: 'ip_reg_user_id', headerName: 'ip_reg_user_id', width: 0, headerAlign: 'center' },
            { field: 'ip_reg_user_name', headerName: '등록자', width: 110, headerAlign: 'center', align:'center' },
            { field: 'ip_reg_datetime', headerName: '등록일시', width: 160, headerAlign: 'center', align:'center' },
            { field: 'ip_update_user_id', headerName: 'ip_update_user_id', width: 0, headerAlign: 'center' },
            { field: 'ip_update_user_name', headerName: '수정자', width: 110, headerAlign: 'center', align:'center' },
            { field: 'ip_update_datetime', headerName: '수정일시', width: 160, headerAlign: 'center', align:'center' }
        ]);
    }

    // Grid 데이터 조회
    const handleView = () => {
        if (appStore.loading) return;
        appStore.setLoading(true);
        
        axios.get('/api/p/CompanySetting/Select')
        .then((response) => {
            setInputs({
                company_id : (response.data)[0].company_id,
                company_cd : (response.data)[0].company_cd,
                company_type : (response.data)[0].company_type,
                company_group : (response.data)[0].company_group,
                company_customer_type : (response.data)[0].company_customer_type,
                company_number : ((response.data)[0].company_number === undefined?'':
                    (response.data)[0].company_number
                    .replace(/[^0-9.]/g, "")
                    .replace(/^(\d{0,3})(\d{0,2})(\d{0,5})$/g, "$1-$2-$3")
                    .replace(/(-{1,2})$/g, "")),
                company_law_number : ((response.data)[0].company_law_number === undefined?'':
                    (response.data)[0].company_law_number
                    .replace(/[^0-9.]/g, "")
                    .replace(/^(\d{0,6})(\d{0,7})$/g, "$1-$2")
                    .replace(/(-{1})$/g, "")),
                company_name : (response.data)[0].company_name,
                company_kpi_key : (response.data)[0].company_kpi_key,
                company_conditions : (response.data)[0].company_conditions,
                company_jongmok : (response.data)[0].company_jongmok,
                company_ceo : (response.data)[0].company_ceo,
                company_ceo_phone : ((response.data)[0].company_ceo_phone === undefined?'':
                    (response.data)[0].company_ceo_phone
                    .replace(/[^0-9.]/g, "")
                    .replace(/^(\d{0,3})(\d{0,4})(\d{0,4})$/g, "$1-$2-$3")
                    .replace(/(-{1,2})$/g, "")),
                company_ip_control_yn: (response.data)[0].company_ip_control_yn,
                company_address_post : (response.data)[0].company_address_post,
                company_address : (response.data)[0].company_address,
                company_address_addition : (response.data)[0].company_address_addition,
                company_contact_name : (response.data)[0].company_contact_name,
                company_contact_phone : ((response.data)[0].company_contact_phone === undefined?'':
                    (response.data)[0].company_contact_phone
                    .replace(/[^0-9.]/g, "")
                    .replace(/^(\d{0,3})(\d{0,4})(\d{0,4})$/g, "$1-$2-$3")
                    .replace(/(-{1,2})$/g, "")),
                company_contact_mail : (response.data)[0].company_contact_mail
            });
            
            var license_array = response.data.map((item, index) => ({
                id: item.company_license_seq,
                license_start_date: item.company_license_start_date,
                license_end_date: item.company_license_end_date,
                license_reg_user_name: item.company_license_reg_user_name,
                license_reg_datetime: Moment(item.company_license_reg_datetime).format('YYYY-MM-DD HH:mm:ss'),
                row_type: 'O',
                update_type: 'N'
            }));
            license_array = license_array.filter((element) => typeof element.id !== 'undefined');
            setLicenseRows([ ...new Set((license_array).map(JSON.stringify)) ].map(JSON.parse));
            setLicenseOriginRows([ ...new Set((license_array).map(JSON.stringify)) ].map(JSON.parse));
            
            var hardware_array = response.data.map((item, index) => ({
                id: item.company_hardware_seq,
                hardware_type: item.company_hardware_type,
                hardware_uuid: item.company_hardware_uuid,
                hardware_reg_user_name: item.company_hardware_reg_user_name,
                hardware_reg_datetime: Moment(item.company_hardware_reg_datetime).format('YYYY-MM-DD HH:mm:ss'),
                row_type: 'O',
                update_type: 'N'
            }));
            hardware_array = hardware_array.filter((element) => typeof element.id !== 'undefined');
            setHardwareRows([ ...new Set((hardware_array).map(JSON.stringify)) ].map(JSON.parse));
            setHardwareOriginRows([ ...new Set((hardware_array).map(JSON.stringify)) ].map(JSON.parse));

            var ip_array = response.data.map((item, index) => ({
                id: item.company_ip_seq,
                company_allow_ip: item.company_allow_ip,
                ip_reg_user_id: item.ip_reg_user_id,
                ip_reg_user_name: item.ip_reg_user_name,
                ip_reg_datetime: Moment(item.ip_reg_datetime).format('YYYY-MM-DD HH:mm:ss'),
                ip_update_user_id: item.ip_update_user_id,
                ip_update_user_name: item.ip_update_user_name,
                ip_update_datetime: (item.ip_update_datetime === undefined?"":Moment(item.ip_update_datetime).format('YYYY-MM-DD HH:mm:ss')),
                row_type: 'O',
                update_type: 'N'
            }));
            ip_array = ip_array.filter((element) => typeof element.id !== 'undefined');
            setIpRows([ ...new Set((ip_array).map(JSON.stringify)) ].map(JSON.parse));
        })
        .catch((error) => {
            appStore.capture();
        })
        .finally(() => {
            appStore.setLoading(false); 
        });

    }
    
    const handleInitSelect = () => {
        // 유형, 업종 코드
        axios.get('/api/Common/CodeDetailList')
        .then((response) => { 

            var type_array = [];
            var group_array = [];
            for(let i=0; i<(response.data).length; i++){
                if((response.data)[i].code_id === '0001'){
                    type_array.push({ value: (response.data)[i].code_detail_seq, label: (response.data)[i].code_detail_name });
                }else if((response.data)[i].code_id === '0002'){
                    group_array.push({ value: (response.data)[i].code_detail_seq, label: (response.data)[i].code_detail_name });
                }
            }

            setTypeOption(type_array);
            setGroupOption(group_array);
        })
        .catch((error) => {
            console.log(error);
        });

        var array = [
            {value:'Y', label:'Y'}
            ,{value:'N', label:'N'}
        ];
        setYNOption([ {value:'Y', label:'Y'} ,{value:'N', label:'N'}]);
    }

    const onSelectChange = (type, value) => {
        const nextInputs = {
            ...inputs,
            [type] : value
        };
        setInputs(nextInputs);
    };

    const onChange = (e)=>{
        const {name, value} = e.target;
        const nextInputs = {
            ...inputs,
            [name]: value, 
        };
        setInputs(nextInputs);
    };

    const onHypenChange = (e)=>{
        const {name, value} = e.target;
        var hyphen_data = ''
        if(e.target.name === 'company_ceo_phone' || e.target.name === 'company_contact_phone'){ // 전화번호인 경우
            hyphen_data = e.target.value
            .replace(/[^0-9.]/g, "")
            .replace(/^(\d{0,3})(\d{0,4})(\d{0,4})$/g, "$1-$2-$3")
            .replace(/(-{1,2})$/g, "");
        } else if(e.target.name === 'company_number'){ // 사업자번호인 경우
            hyphen_data = e.target.value
            .replace(/[^0-9.]/g, "")
            .replace(/^(\d{0,3})(\d{0,2})(\d{0,5})$/g, "$1-$2-$3")
            .replace(/(-{1,2})$/g, "");
        } else if(e.target.name === 'company_law_number'){ // 법인번호인 경우
            hyphen_data = e.target.value
            .replace(/[^0-9.]/g, "")
            .replace(/^(\d{0,6})(\d{0,7})$/g, "$1-$2")
            .replace(/(-{1})$/g, "");
        } else if(e.target.name === 'company_kpi_key'){ // KPI Key인 경우
            hyphen_data = e.target.value;
        }

        const nextInputs = {
            ...inputs,
            [name]: hyphen_data, 
        };
        setInputs(nextInputs);
    };

    const processLicenseRowUpdate = (newRow, oldRow) => {
        const newUpdateDataArray = { ...newRow, update_type: 'U' }; // 값 변경이 있는 경우
        const newNoDataArray = { ...newRow, update_type: 'N' }; // 값 변경이 없는 경우
        
        if(newRow.license_start_date !== oldRow.license_start_date || newRow.license_end_date !== oldRow.license_end_date || newRow.license_reg_user_name !== oldRow.license_reg_user_name){
            var row_license_start_date = '';
            var row_license_end_date = '';
            var row_license_reg_user_name = '';

            if(String(newRow.row_type) === "A"){
                if(newRow.license_start_date !== '' || newRow.license_end_date !== '' || newRow.license_reg_user_name !== ''){
                    row_license_start_date = newRow.license_start_date;
                    row_license_end_date = newRow.license_end_date;
                    row_license_reg_user_name = newRow.license_reg_user_name;
                }
            }else{
                licenseRows.map((data) => data.id === newRow.id 
                    && (data.license_start_date !== newRow.license_start_date || data.license_end_date !== newRow.license_end_date || data.license_reg_user_name !== newRow.license_reg_user_name)?
                    (
                        row_license_start_date = data.license_start_date,
                        row_license_end_date = data.license_end_date,
                        row_license_reg_user_name = data.license_reg_user_name
                    ):""
                )
            }
            
            if(row_license_start_date === '' && row_license_end_date === '' && row_license_reg_user_name === ''){
                // 1. 값이 수정되지 않은 경우.
                if(updateLicenseRows.length > 0){
                    setUpdateLicenseRows(updateLicenseRows.filter((data) => data.id !== newRow.id));
                    setLicenseRows(licenseRows.map((data) => data.id === newRow.id? newNoDataArray : data ));
                }
                return newNoDataArray;
            }else{
                // 2. 값이 수정된 경우.
                var updateRowsYN = 'N'; //updateRows에 있는값인지 확인함.
                for (let i = 0; i < updateLicenseRows.length; i++) {
                    if(updateLicenseRows[i].id === newRow.id){
                        updateRowsYN = 'Y';
                    }
                }

                if(updateRowsYN === 'Y'){
                    setUpdateLicenseRows(updateLicenseRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
                    setLicenseRows(licenseRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
                }else{
                    setUpdateLicenseRows(prevRows => [...prevRows, newUpdateDataArray]);
                    setLicenseRows(licenseRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
                }
                return newUpdateDataArray;
            }
        }
        return { ...newRow };
    };

    const processHardwareRowUpdate = (newRow, oldRow) => {
        const newUpdateDataArray = { ...newRow, update_type: 'U' }; // 값 변경이 있는 경우
        const newNoDataArray = { ...newRow, update_type: 'N' }; // 값 변경이 없는 경우
        
        if(newRow.hardware_type !== oldRow.hardware_type || newRow.hardware_uuid !== oldRow.hardware_uuid || newRow.hardware_reg_user_name !== oldRow.hardware_reg_user_name){
            var row_hardware_type = '';
            var row_hardware_uuid = '';
            var row_hardware_reg_user_name = '';

            if(String(newRow.row_type) === "A"){
                if(newRow.hardware_type !== '' || newRow.hardware_uuid !== '' || newRow.hardware_reg_user_name !== ''){
                    row_hardware_type = newRow.hardware_type;
                    row_hardware_uuid = newRow.hardware_uuid;
                    row_hardware_reg_user_name = newRow.hardware_reg_user_name;
                }
            }else{
                hardwareRows.map((data) => data.id === newRow.id 
                    && (data.hardware_type !== newRow.hardware_type || data.hardware_uuid !== newRow.hardware_uuid || data.hardware_reg_user_name !== newRow.hardware_reg_user_name)?
                    (
                        row_hardware_type = data.hardware_type,
                        row_hardware_uuid = data.hardware_uuid,
                        row_hardware_reg_user_name = data.hardware_reg_user_name
                    ):""
                )
            }
            
            if(row_hardware_type === '' && row_hardware_uuid === '' && row_hardware_reg_user_name === ''){
                // 1. 값이 수정되지 않은 경우.
                if(updateHardwareRows.length > 0){
                    setUpdateHardwareRows(updateHardwareRows.filter((data) => data.id !== newRow.id));
                    setHardwareRows(hardwareRows.map((data) => data.id === newRow.id? newNoDataArray : data ));
                }
                return newNoDataArray;
            }else{
                // 2. 값이 수정된 경우.
                var updateRowsYN = 'N'; //updateRows에 있는값인지 확인함.
                for (let i = 0; i < updateHardwareRows.length; i++) {
                    if(updateHardwareRows[i].id === newRow.id){
                        updateRowsYN = 'Y';
                    }
                }

                if(updateRowsYN === 'Y'){
                    setUpdateHardwareRows(updateHardwareRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
                    setHardwareRows(hardwareRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
                }else{
                    setUpdateHardwareRows(prevRows => [...prevRows, newUpdateDataArray]);
                    setHardwareRows(hardwareRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
                }
                return newUpdateDataArray;
            }
        }
        return { ...newRow };
    };

    const processIpRowUpdate = (newRow, oldRow) => {
        const newUpdateDataArray = { ...newRow, update_type: 'U' }; // 값 변경이 있는 경우
        const newNoDataArray = { ...newRow, update_type: 'N' }; // 값 변경이 없는 경우

        if(newRow.company_allow_ip !== oldRow.company_allow_ip){
            var row_company_allow_ip = '';
            if(String(newRow.row_type) === "A"){
                if((newRow.company_allow_ip).trim() !== ''){
                    row_company_allow_ip = (newRow.company_allow_ip).trim();
                }
            }else{
                ipRows.map((data) => data.id === newRow.id 
                    && ((data.company_allow_ip).trim() !== (newRow.company_allow_ip).trim())?
                    (
                        row_company_allow_ip = (data.company_allow_ip).trim()
                    ):""
                )
            }
            
            if((row_company_allow_ip).trim() === ''){
                // 1. 값이 수정되지 않은 경우.
                if(updateIpRows.length > 0){
                    setUpdateIpRows(updateIpRows.filter((data) => data.id !== newRow.id));
                    setIpRows(ipRows.map((data) => data.id === newRow.id? newNoDataArray : data ));
                }
                return newNoDataArray;
            }else{
                // 2. 값이 수정된 경우.
                var updateRowsYN = 'N'; //updateRows에 있는값인지 확인함.
                for (let i = 0; i < updateIpRows.length; i++) {
                    if(updateIpRows[i].id === newRow.id){
                        updateRowsYN = 'Y';
                    }
                }

                if(updateRowsYN === 'Y'){
                    setUpdateIpRows(updateIpRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
                    setIpRows(ipRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
                }else{
                    setUpdateIpRows(prevRows => [...prevRows, newUpdateDataArray]);
                    setIpRows(ipRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
                }
                return newUpdateDataArray;
            }
        }
        return { ...newRow };
    };

    const licenseAddClick = (object) => {
        //라이센스 추가 버튼
        setLicenseRows((licenseRows) => [...licenseRows, { 
            id: Number(appStore.getMaxListID(licenseRows))+1,
            license_start_date: '',
            license_end_date: '',
            license_reg_user_name: '',
            license_reg_datetime: '',
            row_type:'A',
            update_type: 'N'
        }]);
    };

    const licenseDeleteClick = (object) => {
        //라이센스 삭제 버튼
        setUpdateLicenseRows((updateLicenseRows) => updateLicenseRows.filter((data) => data.id !== object.row.id));
        if(object.row.row_type === 'O'){
            setUpdateLicenseRows(prevRows => [...prevRows, {
                id: object.row.id,
                license_start_date: object.row.license_start_date,
                license_end_date: object.row.license_end_date,
                license_reg_user_name: object.row.license_reg_user_name,
                license_reg_datetime: object.row.license_reg_datetime,
                row_type:'O',
                update_type: 'D'
            }]);
        }
        setLicenseRows((licenseRows) => licenseRows.filter((data) => data.id !== object.row.id));
    };

    const hardwareAddClick = (object) => {
        //하드웨어 추가 버튼
        setHardwareRows((hardwareRows) => [...hardwareRows, { 
            id: Number(appStore.getMaxListID(hardwareRows))+1,
            hardware_type: 'P',
            hardware_uuid: '',
            hardware_reg_user_name: '',
            hardware_reg_datetime: '',
            row_type:'A',
            update_type: 'N'
        }]);
    };

    const hardwareDeleteClick = (object) => {
        //하드웨어 삭제 버튼
        setUpdateHardwareRows((updateHardwareRows) => updateHardwareRows.filter((data) => data.id !== object.row.id));
        if(object.row.row_type === 'O'){
            setUpdateHardwareRows(prevRows => [...prevRows, {
                id: object.row.id,
                hardware_type: object.row.hardware_type,
                hardware_uuid: object.row.hardware_uuid,
                hardware_reg_user_name: object.row.hardware_reg_user_name,
                hardware_reg_datetime: object.row.hardware_reg_datetime,
                row_type:'O',
                update_type: 'D'
            }]);
        }
        setHardwareRows((hardwareRows) => hardwareRows.filter((data) => data.id !== object.row.id));
    };

    const ipAddClick = (object) => {
        //IP 추가 버튼
        setIpRows((ipRows) => [...ipRows, { 
            id: Number(appStore.getMaxListID(ipRows))+1,
            company_allow_ip: '',
            ip_reg_user_id: 0,
            ip_reg_user_name: '',
            ip_reg_datetime: '',
            ip_update_user_id: 0,
            ip_update_user_name: '',
            ip_update_datetime: '',
            row_type:'A',
            update_type: 'N'
        }]);
    };

    const ipDeleteClick = (object) => {
        //IP 삭제 버튼
        setUpdateIpRows((updateIpRows) => updateIpRows.filter((data) => data.id !== object.row.id));
        if(object.row.row_type === 'O'){
            setUpdateIpRows(prevRows => [...prevRows, {
                id: object.row.id,
                company_allow_ip: object.row.company_allow_ip,
                ip_reg_user_id: object.row.ip_reg_user_id,
                ip_reg_user_name: object.row.ip_reg_user_name,
                ip_reg_datetime: object.row.ip_reg_datetime,
                ip_update_user_id: object.row.ip_update_user_id,
                ip_update_user_name: object.row.ip_update_user_name,
                ip_update_datetime: object.row.ip_update_datetime,
                row_type:'O',
                update_type: 'D'
            }]);
        }
        setIpRows((ipRows) => ipRows.filter((data) => data.id !== object.row.id));
    };

    const handleSave = () => {
        // 이름 확인 정규식(2-20 자리 영문소+영문대+한글+띄어쓰기 입력 가능) : !(/^[가-힣a-zA-z\s]{2,20}$/).test(inputs.user_name.trim())
        // 날짜 확인 정규식(19@@년도 입력 불가) : !(/^2[0-1]\d{2}-(0[0-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])$/).test(inputs.user_start_date.trim())
        // 날짜 확인 정규식(19@@년도 입력 가능) : !(/^(19\d{2}|2[0-1]\d{2})-(0[0-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])$/).test(inputs.user_start_date.trim())
        // 휴대폰 정규식(010-숫자4자리-숫자4자리 입력 가능) : !(/^010-\d{4}-\d{4}$/).test(inputs.user_phone.trim())
        // 전화번호 정규식(숫자3자리-숫자4자리-숫자4자리) : !(/^\d{3}-(\d{3,4})-\d{4}$/).test(inputs.user_call.trim())
        // E-Mail 정규식 : !(/^[-A-Za-z0-9_]+[-A-Za-z0-9_.]*[@]{1}[-A-Za-z0-9_]+[-A-Za-z0-9_.]*[.]{1}[A-Za-z]{1,5}$/).test(inputs.user_email.trim())
        // 계좌번호 정규식(숫자, 하이픈 5-30자리 이하) : !(/^[0-9-]{5,30}$/).test(inputs.bank_number.trim())
        let msg = '';
        if(inputs.company_name.trim() === ''){
          msg = '회사명은 필수로 입력 해주세요.';
        }else if(inputs.company_type === 0){
          msg = '회사유형는 필수로 선택 해주세요.';
        }else if(inputs.company_group === 0){
          msg = '회사업종는 필수로 선택 해주세요.';
        }else if (String(inputs?.company_kpi_key ?? '').trim() !== '' && !/^([A-Za-z0-9_]{4}-){3}[A-Za-z0-9_]{4}$/.test(String(inputs?.company_kpi_key ?? '').trim())) {
          msg = 'KPI Key 입력이 올바르지 않습니다.<br/>(입력 양식 : 4자리-4자리-4자리-4자리)';
        }else if(inputs.company_number.trim() === ''){
          msg = '사업자번호는 필수로 입력 해주세요.<br/>(입력 양식 : 숫자3자리-숫자2자리-숫자5자리)';
        }else if(!(/^\d{3}-(\d{2})-\d{5}$/).test(inputs.company_number.trim())){
          msg = '사업자번호 입력이 올바르지 않습니다.<br/>(입력 양식 : 숫자3자리-숫자2자리-숫자5자리)';
        }else if(inputs.company_law_number.trim() !== '' && !(/^\d{6}-(\d{7})/).test(inputs.company_law_number.trim())){
          msg = '법인번호 입력이 올바르지 않습니다.<br/>(입력 양식 : 숫자6자리-숫자7자리)';
        }else if(inputs.company_ceo_phone.trim() !== '' && !(/^010-\d{4}-\d{4}$/).test(inputs.company_ceo_phone.trim())){
          msg = '대표자 휴대번호 입력이 올바르지 않습니다.<br/>(입력 양식 : 010-숫자4자리-숫자4자리)';
        }else if(inputs.company_contact_phone.trim() !== '' && !(/^\d{3}-(\d{3,4})-\d{4}$/).test(inputs.company_contact_phone.trim())){
          msg = '담당자 휴대번호 입력이 올바르지 않습니다.<br/>(입력 양식 : 010-숫자4자리-숫자4자리)';
        }else if(inputs.company_contact_mail.trim() !== '' && !(/^[-A-Za-z0-9_]+[-A-Za-z0-9_.]*[@]{1}[-A-Za-z0-9_]+[-A-Za-z0-9_.]*[.]{1}[A-Za-z]{1,5}$/).test(inputs.company_contact_mail.trim())){
          msg = '담당자 E-Mail 입력이 올바르지 않습니다.';
        }

        if(updateIpRows.length > 0 && msg === ''){
            for(let i = 0; i < ipRows.length; i++) {
                const currElem = (ipRows[i].company_allow_ip).trim();
                for(let j = i+1; j < ipRows.length; j++) {
                    if(currElem === (ipRows[j].company_allow_ip).trim() && currElem !== '') {
                        msg = '중복된 허용IP가 존재합니다.<br/>[중복된 허용IP : '+currElem+']';
                        break;
                    }
                }
        
                if(msg !== '')  {
                    break;
                }
            }
        
            for(let i = 0; i < updateIpRows.length; i++) {
                const currElem = (updateIpRows[i].company_allow_ip).trim();
                if(currElem === '') {
                msg = '입력되지 않은 허용IP가 존재합니다.';
                break;
                }
            }
        }
        
        if(msg !== ''){
          Swal.fire({
            title: '<p style="color:red">시스템설정 수정 오류</p>',
            html: msg,
            confirmButtonText: '확인'
          });
        }else{
            if (appStore.loading) return;
            appStore.setLoading(true);

            axios.post("/api/p/CompanySetting/Update", {inputs,updateIpRows},
             { withCredentials: true })
            .then(function (response) {
                if(response.status === 200){
                    var text = '정상적으로 시스템설정이 수정 되었습니다.';
                    if(updateLicenseRows.length > 0){
                        text = text + '<br/><p style="color:red; padding: 0px; margin:0px;">라이센스 정보는 수정이 불가능합니다.</p>'
                        setLicenseRows(licenseOriginRows);
                        setUpdateLicenseRows([]);
                    }
                    if(updateHardwareRows.length > 0){
                        text = text + '<br/><p style="color:red; padding: 0px; margin:0px;">하드웨어 정보는 수정이 불가능합니다.</p>'
                        setHardwareRows(hardwareOriginRows);
                        setUpdateHardwareRows([]);
                    }
                    setUpdateIpRows([]);

                    Swal.fire({
                        title: '시스템설정 수정 완료',
                        html: text,
                        confirmButtonText: '확인',
                        timer:5000,
                        timerProgressBar: true
                    });
                }else{
                    appStore.capture();
                }
            })
            .catch(function (error) {
                appStore.capture();
            })
            .finally(() => {
                appStore.setLoading(false); 
            });
        }
    };

    const handleTabID = (event, newTabID) => {
        setTabID(newTabID);
    };

    return (
        <div style={ { width:'100%', display: String(MenuID) === String(0) ? 'hidden' : 'block' } }>
            <div className="menubox" style={ { height: '70px', paddingRight: '0px' } }>
                <div className="menu-action" style={ { paddingRight: '0px' } }>
                    <div className="menu-title">{ MenuName }</div>
                        <div className="menu-button">
                            { MenuUpdateYN === "Y" && updateFlag?
                            <Button 
                                onClick={ handleSave }
                                className="btn-p btn-u"
                                sx={{  
                                    m: 1, 
                                    fontSize: 15, 
                                    color: "white", 
                                    borderColor: "#FF3636", 
                                    backgroundColor: "#FF3636",
                                    ":hover": { boxShadow: "2px 2px 2px #FF3636" , backgroundColor: "#FF3636", borderColor: "#FF3636"}
                                }} 
                                variant="outlined">
                                저장
                            </Button> : <></> }
                        </div>
                    </div>
                </div>
            <div className="grid" style={{top:'80px', overflow:'unset'}}>
                <div className="modal" style={{height: "calc(100vh - 200px)", width: '950px', float:'left'}}>
                    <table className="ModalTABLE">
                        <tbody>
                            <tr>
                                <td className="ModalTD" style={{ paddingLeft: '10px' }}>
                                    <div className="modal_filed">
                                        <div className="modal_filed_title" style={ { fontSize: '16px', paddingTop: '10px' } }>회사명<span className="essential">*</span></div>
                                        <div className="modal_filed_input">
                                        <input type="text" placeholder="회사명" style={ { fontSize: '16px' } } value={inputs.company_name} name="company_name" onChange={(e) => onChange(e) } ref={companyNameRef} autoComplete="off" />
                                        </div>
                                    </div>
                                </td>
                                <td className="ModalTD" style={{ paddingLeft: '10px' }}>
                                    <div className="modal_filed">
                                        <div className="modal_filed_title" style={ { fontSize: '16px', paddingTop: '10px' } }>KPI Key</div>
                                        <div className="modal_filed_input">
                                        <input type="text" placeholder="KPI Key" style={ { fontSize: '16px' } } value={inputs.company_kpi_key} name="company_kpi_key" onChange={(e) => onChange(e) } autoComplete="off" />
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td className="ModalTD" style={{ paddingLeft: '10px' }}>
                                    <div className="modal_filed">
                                        <div className="modal_filed_title" style={ { width: '120px', fontSize: '16px', paddingTop: '10px' } }>회사유형<span className="essential">*</span></div>
                                        <div className="modal_filed_input" style={ { width: '273px', paddingLeft: '10px' } }>
                                            <Select style={ { fontSize: '16px', BorderStyle: '1px solid lightgrey' } } placeholder="회사유형" value={typeOption.filter(function (option) { return option.value === inputs.company_type; })} onChange={(e) => onSelectChange('company_type',e.value)} options={typeOption} noOptionsMessage={() => "조회되는 항목 없음"} />
                                        </div>
                                    </div>
                                </td>
                                <td className="ModalTD" style={{ paddingLeft: '10px' }}>
                                    <div className="modal_filed">
                                        <div className="modal_filed_title" style={ { width: '120px', fontSize: '16px', paddingTop: '10px' } }>회사업종<span className="essential">*</span></div>
                                        <div className="modal_filed_input" style={ { width: '284px', paddingLeft: '10px' } }>
                                            <Select style={ { fontSize: '16px', BorderStyle: '1px solid lightgrey' } } placeholder="회사업종" value={groupOption.filter(function (option) { return option.value === inputs.company_group; })} onChange={(e) => onSelectChange('company_group',e.value)} options={groupOption} noOptionsMessage={() => "조회되는 항목 없음"} />
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td className="ModalTD" style={{ paddingLeft: '10px' }}>
                                    <div className="modal_filed">
                                        <div className="modal_filed_title" style={ { fontSize: '16px', paddingTop: '10px' } }>사업자번호<span className="essential">*</span></div>
                                        <div className="modal_filed_input">
                                        <input type="text" placeholder="사업자번호" style={ { fontSize: '16px' } } value={inputs.company_number} name="company_number" onChange={(e) => onHypenChange(e) } autoComplete="off" />
                                        </div>
                                    </div>
                                </td>
                                <td className="ModalTD" style={{ paddingLeft: '10px' }}>
                                    <div className="modal_filed">
                                        <div className="modal_filed_title" style={ { fontSize: '16px', paddingTop: '10px' } }>법인번호</div>
                                        <div className="modal_filed_input">
                                        <input type="text" placeholder="법인번호" style={ { fontSize: '16px' } } value={inputs.company_law_number} name="company_law_number" onChange={(e) => onHypenChange(e) } autoComplete="off" />
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            
                            <tr>
                                <td className="ModalTD" colSpan={2} style={{ paddingLeft: '10px' }}>
                                    <div className="modal_filed">
                                        <div className="modal_filed_title" style={ { fontSize: '16px', paddingTop: '10px' } }>
                                            대표자
                                        </div>
                                        <div className="modal_filed_input">
                                            <input type="text" placeholder="이름" style={ { fontSize: '16px' } } value={inputs.company_ceo} name="company_ceo" onChange={(e) => onChange(e) } autoComplete="off" />
                                        </div>
                                        <div className="modal_filed_input" style={ { width: '245px', paddingLeft: '20px' } }>
                                            <input type="text" placeholder="휴대폰번호" style={ { width: '200px', fontSize: '16px' } } value={inputs.company_ceo_phone} name="company_ceo_phone" onChange={(e) => onHypenChange(e) } autoComplete="off" />
                                        </div>
                                        <div className="modal_filed_title" style={{ fontSize: '16px', paddingTop: '10px' }} >IP제한</div> 
                                        <div className="modal_filed_input" style={ { width: '131px' } }>
                                            <Select style={ { width: '145px', fontSize: '16px', BorderStyle: '1px solid lightgrey' } } placeholder="IP제한" value={ynOption.filter(function (option) { return option.value === inputs.company_ip_control_yn; })} onChange={(e) => onSelectChange('company_ip_control_yn',e.value)} options={ynOption} noOptionsMessage={() => "조회되는 항목 없음"} />
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td className="ModalTD" colSpan={2} style={{ paddingLeft: '10px' }}>
                                <div className="modal_filed">
                                    <div className="modal_filed_title" style={ { fontSize: '16px', paddingTop: '10px' } }>담당자</div>
                                    <div className="modal_filed_input">
                                        <input type="text" placeholder="이름" style={ { fontSize: '16px' } } value={inputs.company_contact_name} name="company_contact_name" onChange={(e) => onChange(e) } autoComplete="off" />
                                    </div>
                                    <div className="modal_filed_input" style={ { width: '245px', paddingLeft: '20px' } }>
                                        <input type="text" placeholder="휴대폰번호" style={ { width: '200px', fontSize: '16px' } } value={inputs.company_contact_phone} name="company_contact_phone" onChange={(e) => onHypenChange(e) } autoComplete="off" />
                                    </div>
                                    <div className="modal_filed_input">
                                        <input type="text" placeholder="메일주소" style={ { width: '248px', fontSize: '16px' } } value={inputs.company_contact_mail} name="company_contact_mail" onChange={(e) => onChange(e) } autoComplete="off" />
                                    </div>
                                </div>
                                </td>
                            </tr>
                            <tr>
                                <td className="ModalTD" style={{ paddingLeft: '10px' }}>
                                    <div className="modal_filed">
                                        <div className="modal_filed_title" style={ { fontSize: '16px', paddingTop: '10px' } }>업태<span className="essential">*</span></div>
                                        <div className="modal_filed_input">
                                        <input type="text" placeholder="업태" style={ { fontSize: '16px' } } value={inputs.company_conditions} name="company_conditions" onChange={(e) => onChange(e) } autoComplete="off" />
                                        </div>
                                    </div>
                                </td>
                                <td className="ModalTD" style={{ paddingLeft: '10px' }}>
                                    <div className="modal_filed">
                                        <div className="modal_filed_title" style={ { fontSize: '16px', paddingTop: '10px' } }>종목</div>
                                        <div className="modal_filed_input">
                                        <input type="text" placeholder="종목" style={ { fontSize: '16px' } } value={inputs.company_jongmok} name="company_jongmok" onChange={(e) => onChange(e) } autoComplete="off" />
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td className="ModalTD" colSpan={2} style={{ paddingLeft: '10px' }}>
                                <div className="modal_filed">
                                    <div className="modal_filed_title" style={ { fontSize: '16px', paddingTop: '10px' } }>담당자</div>
                                    <div className="modal_filed_input">
                                        <input type="text" placeholder="우편번호" style={ { fontSize: '16px' } } value={inputs.company_address_post} name="company_address_post" onChange={(e) => onChange(e) } autoComplete="off" />
                                    </div>
                                    <div className="modal_filed_input" style={ { width: '245px', paddingLeft: '20px' } }>
                                        <input type="text" placeholder="주소" style={ { width: '200px', fontSize: '16px' } } value={inputs.company_address} name="company_address" onChange={(e) => onHypenChange(e) } autoComplete="off" />
                                    </div>
                                    <div className="modal_filed_input">
                                        <input type="text" placeholder="상세주소" style={ { width: '248px', fontSize: '16px' } } value={inputs.company_address_addition} name="company_address_addition" onChange={(e) => onChange(e) } autoComplete="off" />
                                    </div>
                                </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                    <div className="modal" style={{height: "calc(100vh - 200px)", width: 'calc(100% - 970px)', height:'441px', float:'right'}}>
                        <div className="grid" style={{ top: '15px', width: 'calc(100% - 990px)', height:'441px' }}>
                            <TabContext value={tabID}>
                                <Box sx={{ top:'200px', borderBottom: 1, borderColor: 'divider' }}>
                                    <TabList onChange={handleTabID}>
                                        <Tab label="라이센스" value="1" />
                                        <Tab label="하드웨어" value="2" />
                                        <Tab label="IP" value="3" />
                                    </TabList>
                                </Box>
                                <TabPanel value="1">
                                    <div className="grid_sub" style={ { height: '390px' } }>
                                        <DataGrid
                                            className="datagrid"
                                            rows={licenseRows}
                                            columns={licenseColumns}
                                            slots={{
                                                noRowsOverlay: GridNoRow,
                                            }}
                                            columnVisibilityModel={licenseColumnVisibilityModel}
                                            editMode='cell'
                                            processRowUpdate={processLicenseRowUpdate}
                                            AlternatingRowBackground="LavenderBlush"
                                            rowsPerPageOptions={[20, 50, 100]}
                                            initialState={{ 
                                                density: 'compact'
                                            }}
                                        />
                                    </div>
                                </TabPanel>
                                <TabPanel value="2">
                                    <div className="grid_sub" style={ { height: '390px' } }>
                                        <DataGrid
                                            className="datagrid"
                                            rows={hardwareRows}
                                            columns={hardwareColumns}
                                            slots={{
                                                noRowsOverlay: GridNoRow,
                                            }}
                                            columnVisibilityModel={hardwareColumnVisibilityModel}
                                            editMode='cell'
                                            processRowUpdate={processHardwareRowUpdate}
                                            AlternatingRowBackground="LavenderBlush"
                                            rowsPerPageOptions={[20, 50, 100]}
                                            initialState={{ 
                                                density: 'compact'
                                            }}
                                        />
                                    </div>
                                </TabPanel>
                                <TabPanel value="3">
                                    <div className="grid_sub" style={ { height: '390px' } }>
                                        <DataGrid
                                            className="datagrid"
                                            rows={ipRows}
                                            columns={ipColumns}
                                            slots={{
                                                noRowsOverlay: GridNoRow,
                                            }}
                                            columnVisibilityModel={ipColumnVisibilityModel}
                                            editMode='cell'
                                            processRowUpdate={processIpRowUpdate}
                                            AlternatingRowBackground="LavenderBlush"
                                            rowsPerPageOptions={[20, 50, 100]}
                                            initialState={{ 
                                                density: 'compact'
                                            }}
                                        />
                                    </div>
                                </TabPanel>
                            </TabContext>
                        </div>
                    </div>
            </div>
        </div>
    )
}

const AppWrap = styled.div`
  text-align: center;
  margin: 50px auto;
`;



export default CompanySetting;
